import { render, staticRenderFns } from "./carNumber.vue?vue&type=template&id=677b3a10&"
import script from "./carNumber.vue?vue&type=script&lang=js&"
export * from "./carNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/input/carNumber.vue"
export default component.exports